import { useSelector } from 'react-redux';
import { getPlanExpiresIn } from 'domains/Auth/authSlice/authSelectors';

function useGetPlanExpiresIn() {
  return useSelector(getPlanExpiresIn);
}

export default useGetPlanExpiresIn;
